const modulesData = [
	{
		id: 'module-1',
		title: 'Modul 1',
		subtitle: 'DEN SVÆRE CIRKEL',
		colorId: 'purple',
		description: `I får kendskab til kollektiv illusion og den svære cirkel. I øver jer på at genkende udfordringer fra den svære cirkel og på at forstå, hvordan udfordringer kan påvirke hinanden.`,
		pages: require('data/module-pages/module-1-pages').modulePages,
	},
	{
		id: 'module-2',
		title: 'Modul 2',
		subtitle: 'ALARMHJERNEN OG TÆNKEHJERNEN',
		colorId: 'green',
		description: `I får kendskab til, hvordan alarmhjernen kan tage over, og I får konkrete redskaber til, hvad man kan gøre for at få ro på og komme tilbage til 'tænkehjernen'.`,
		pages: require('data/module-pages/module-2-pages').modulePages,
		requiredModuleId: 'module-1',
	},
	{
		id: 'module-3',
		title: 'Modul 3',
		subtitle: 'SØVN',
		colorId: 'yellow',
		description: `I får viden om de helt almindelige udfordringer, man kan møde som teenager, når det kommer til søvn. I får også helt konkret viden om, hvad man kan gøre, for at gøre det nemmere at få en god nats søvn.`,
		pages: require('data/module-pages/module-3-pages').modulePages,
		requiredModuleId: 'module-2',
	},
	{
		id: 'module-4',
		title: 'Modul 4',
		subtitle: 'KOMMUNIKATION',
		colorId: 'pink',
		description: `I får viden om kommunikation og I oplever, hvordan respektfuld kommunkation kan give et godt fællesskab med andre - både i klassen  og uden for klassen.`,
		pages: require('data/module-pages/module-4-pages').modulePages,
		requiredModuleId: 'module-3',
	},
	{
		id: 'module-5',
		title: 'Modul 5',
		subtitle: 'TANKELABYRINTER',
		colorId: 'blue',
		description: `I får viden om, hvordan vores tanker fungerer, og I prøver at flytte jeres opmærksomhed væk fra en helt almindelig 'hvad-nu-hvis-tanke'. `,
		pages: require('data/module-pages/module-5-pages').modulePages,
		requiredModuleId: 'module-4',
	},
	{
		id: 'module-6',
		title: 'Modul 6',
		subtitle: 'TOLKNINGER OG KONFLIKTER',
		colorId: 'orange',
		description: `I prøver at vende tankelabyrinter til mere brugbare tanker. I undersøger hvordan man kan tolke følelser, og arbejder med at håndtere konflikter.`,
		pages: require('data/module-pages/module-6-pages').modulePages,
		requiredModuleId: 'module-5',
	},
	{
		id: 'module-7',
		title: 'Modul 7',
		subtitle: 'TANKER OG HANDLINGER',
		colorId: 'purple',
		description: `I bruger jeres viden om kommunikation, tanker, tolkninger og konflikter, til at arbejde med cases og give casepersonerne gode råd.`,
		pages: require('data/module-pages/module-7-pages').modulePages,
		requiredModuleId: 'module-6',
	},
	{
		id: 'module-8',
		title: 'Modul 8',
		subtitle: 'BASAL I VORES KLASSE',
		colorId: 'green',
		description: `I quizzer om hvad I har lært på Basal, og I lægger en plan for det, klassen har lyst til at fortsætte med at bruge fra Basal.`,
		pages: require('data/module-pages/module-8-pages').modulePages,
		requiredModuleId: 'module-7',
	},

];

export {
	modulesData
};